import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BCBaseComponent } from './bc-base/bc-base.component';
import { BCAuthGuard } from 'src/app/core/guard/bc_auth.guard';

const routes: Routes = [
  {
    path: "",
    component: BCBaseComponent,
    canActivate: [BCAuthGuard],
    children: [
      { path: "", redirectTo: "bc_balance", pathMatch: "full" },
      {
        path: 'bc_balance',
        loadChildren: () => import('../pages/BC_master/bc-balance/bc-balance.module').then(m => m.BCBalanceModule)
      },
      {
        path: 'card_balance',
        loadChildren: () => import("../pages/BC_master/your-cards-details/your-cards.module").then((m) => m.YourCardsModule)
      },
      {
        path: 'addbeneficiary',
        loadChildren: () => import("../pages/BC_master/add-beneficiary/add-beneficiary.module").then((m) => m.AddBeneficiaryModule)
      },
      {
        path: 'viewbeneficiary',
        loadChildren: () => import("../pages/BC_master/view-beneficiary/view-beneficiary.module").then((m) => m.ViewBeneficiaryModule)
      },
      {
        path: 'addscheduledpayments',
        loadChildren: () => import("../pages/BC_master/add-scheduled-payments/add-scheduled-payments.module").then((m) => m.AddScheduledPaymentsModule)
      },
      {
        path: 'onceoffpayments',
        loadChildren: () => import("../pages/BC_master/once-off-payments/once-off-payments.module").then((m) => m.OnceOffPaymentsModule)
      },
      {
        path: 'paymenthistory',
        loadChildren: () => import("../pages/BC_master/payment-history/payment-history.module").then((m) => m.PaymentHistoryModule)
      },
      {
        path: 'ab_addbeneficiary',
        loadChildren: () => import("../pages/BC_master/aittime-and-bundles-add-beneficiary/aittime-and-bundles-add-beneficiary.module").then((m) => m.AittimeAndBundlesAddBeneficiaryModule)
      },
      {
        path: 'ab_viewbeneficiary',
        loadChildren: () => import("../pages/BC_master/aittime-and-bundles-view-beneficiary/aittime-and-bundles-view-beneficiary.module").then((m) => m.AittimeAndBundlesViewBeneficiaryModule)
      },
      {
        path: 'ab_viewhistory',
        loadChildren: () => import("../pages/BC_master/aittime-and-bundles-view-history/aittime-and-bundles-view-history.module").then((m) => m.AittimeAndBundlesViewHistoryModule)
      },
      {
        path: 'bc_smssetup',
        loadChildren: () => import("../pages/BC_master/smssetup/smssetup.module").then((m) => m.SMSsetupModule)
      },
      {
        path: 'bc_blockcard',
        loadChildren: () => import("../pages/BC_master/blockcard/blockcard.module").then((m) => m.BlockcardModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BCLayoutRoutingModule { }
